/**
 * Extend the core Button block with custom data-bs-toggle attribute
 */
(function (wp) {
	// Only run if wp.hooks is available (Gutenberg editor context)
	if (!wp || !wp.hooks) {
		return;
	}

	// Check if all required WordPress APIs are available
	if (!wp.element || !wp.blockEditor || !wp.components || !wp.i18n) {
		// console.warn('jra25: Required WordPress APIs not available');
		return;
	}

	const { addFilter } = wp.hooks;
	const { Fragment, createElement } = wp.element;
	const { InspectorControls } = wp.blockEditor;
	const { PanelBody, TextControl } = wp.components;
	const { __ } = wp.i18n;

	/**
	 * Add dataBsToggle attribute to block settings
	 */
	function addDataBsToggleAttribute(settings, name) {
		if (name !== 'core/button') {
			return settings;
		}

		return Object.assign({}, settings, {
			attributes: Object.assign({}, settings.attributes, {
				dataBsToggle: {
					type: 'string',
					default: '',
				},
			}),
		});
	}

	addFilter(
		'blocks.registerBlockType',
		'jra25/button-data-bs-toggle-attribute',
		addDataBsToggleAttribute
	);

	/**
	 * Add inspector controls to button block
	 */
	function addDataBsToggleInspectorControls(settings, name) {
		if (name !== 'core/button') {
			return settings;
		}

		const originalEdit = settings.edit;
		
		settings.edit = function(props) {
			const { attributes, setAttributes } = props;
			const { dataBsToggle } = attributes;

			return createElement(
				Fragment,
				{},
				createElement(originalEdit, props),
				createElement(
					InspectorControls,
					{},
					createElement(
						PanelBody,
						{
							title: __('Bootstrap Settings', 'jra25'),
							initialOpen: false,
						},
						createElement(TextControl, {
							label: __('Data BS Toggle', 'jra25'),
							value: dataBsToggle || '',
							onChange: function(value) {
								setAttributes({ dataBsToggle: value });
							},
							help: __('Enter Bootstrap toggle value (e.g., modal, dropdown, collapse)', 'jra25'),
						})
					)
				)
			);
		};

		return settings;
	}

	addFilter(
		'blocks.registerBlockType',
		'jra25/button-data-bs-toggle-inspector',
		addDataBsToggleInspectorControls
	);
})(window.wp);

